import React       from 'react';
import styled      from 'styled-components';
import { ICardAd } from '@typings/nationalAdManagement';
import { AdItem }  from './AdItem';

interface IAdPreviewProps {
  adData  : Partial<ICardAd>;
  logoUrl?: string;
}

const Wrapper = styled.div`
  min-height       : 425px;
  width            : 100%;
  background-color : ${({ theme: { width, backgroundColor } }): string => (
    !['lg', 'xl'].includes(width) ? backgroundColor.lightGray : backgroundColor.white)};
`;

const Title = styled.h2`
  max-width : 335px;
  margin    : ${({ theme: { width } }): string => (['lg', 'xl'].includes(width) ? '30px auto' : '15px auto 30px')};
`;

export const AdPreview: React.FC<IAdPreviewProps> = ({
  adData,
  logoUrl,
}) => (
  <Wrapper>
    <Title>Ad Preview</Title>

    <AdItem
      adData     = {adData}
      logoUrl    = {logoUrl}
      onEditAd   = {(): null => null}
      onDeleteAd = {(): null => null}
    />
  </Wrapper>
);
